import { AccreditationNewsItem } from '~/features/accreditation/types';

export const accreditationNewsItems: AccreditationNewsItem[] = [
  {
    type: 'article',
    tag: 'Forbes',
    title: "Udacity's New MBA Shows The Anti-MBA Market Is Splitting In Two",
    description: "Udacity is redefining one of higher education's most recognizable credentials from the inside.",
    href: 'https://www.forbes.com/sites/rayravaglia/2026/03/12/udacitys-new-mba-shows-the-anti-mba-market-is-splitting-in-two/',
  },
  {
    type: 'article',
    tag: 'Poets & Quants',
    title: 'The Accredited $5K MBA Is Now A Reality',
    description:
      "Udacity's accredited MBA in AI Product Management may be the least expensive accredited MBA available anywhere.",
    href: 'https://poetsandquants.com/2026/03/12/the-accredited-5k-mba-is-now-a-reality/?pq-category=news',
  },
  {
    type: 'article',
    tag: 'Fast Company',
    title: 'Here\u2019s how higher education can be a bridge in the AI economy',
    description:
      'If AI is redefining the workplace as a dynamic environment, then education must mirror that same agility.',
    href: 'https://www.fastcompany.com/91447567/heres-how-higher-education-can-be-a-bridge-in-the-ai-economy',
  },
  {
    type: 'article',
    tag: 'DICE',
    title: "Udacity Tackles AI Skills Gap With Master's Program",
    description: "Udacity aims to address a skills gap in AI learning with a modular, accredited master's program.",
    href: 'https://www.dice.com/career-advice/udacity-tackles-ai-skills-gap-with-masters-program',
  },
  {
    type: 'podcast',
    tag: 'Career Buzz',
    title: 'Upskilling for careers of the future',
    description:
      "Isn't there a faster way to gain job-ready tech and AI skills \u2014 without committing to a whole degree program?",
    href: 'https://open.spotify.com/episode/2xJDkghBCQ3MWtkGtOhxN9',
  },
];

export const mastersAiNewsItems: AccreditationNewsItem[] = [
  {
    type: 'article',
    tag: 'Forbes',
    title: "AI Jobs Spike 53%. Now You Can Get A $4,000 Master's Degree",
    description:
      "AI job postings are surging — and an accredited master's degree for under $4,000 is making advanced AI education more accessible than ever.",
    href: 'https://www.forbes.com/sites/rachelwells/2026/02/12/ai-jobs-spike-53-now-you-can-get-a-4000-masters-degree/',
  },
  {
    type: 'article',
    tag: 'DICE',
    title: "Udacity Tackles AI Skills Gap With Master's Program",
    description: "Udacity aims to address a skills gap in AI learning with a modular, accredited master's program.",
    href: 'https://www.dice.com/career-advice/udacity-tackles-ai-skills-gap-with-masters-program',
  },
  {
    type: 'podcast',
    tag: 'Career Buzz',
    title: 'Upskilling for careers of the future',
    description:
      "Isn't there a faster way to gain job-ready tech and AI skills \u2014 without committing to a whole degree program?",
    href: 'https://open.spotify.com/episode/2xJDkghBCQ3MWtkGtOhxN9',
  },
  {
    type: 'article',
    tag: 'IT Brew',
    title: 'Udacity announces low-cost Master of Science in AI',
    description: "As IT practitioners seek upskilling, we explore today's AI training options.",
    href: 'https://www.itbrew.com/stories/2025/10/23/udacity-announces-low-cost-master-of-science-in-ai',
  },
  {
    type: 'article',
    tag: 'Class Central',
    title: "Udacity Just Launched a New Master's Degree in AI: Here's a Look Inside",
    description:
      "Earn Udacity's accredited Master's in AI for 8X less than university degrees. Learn the AI skills employers want through flexible, project-based learning.",
    href: 'https://www.classcentral.com/report/udacity-ai-masters-degree/',
  },
  {
    type: 'article',
    tag: 'Fast Company',
    title: 'How higher education can be a bridge in the AI economy',
    description:
      'If AI is redefining the workplace as a dynamic environment, then education must mirror that same agility.',
    href: 'https://www.fastcompany.com/91447567/heres-how-higher-education-can-be-a-bridge-in-the-ai-economy',
  },
];

export const mbaAiIndiaNewsItems: AccreditationNewsItem[] = [
  {
    type: 'article',
    tag: 'Economic Times',
    title: 'Accenture launches ₹2 Lakh MBA with international accreditation',
    description: 'Udacity and Accenture combine business fundamentals with hands-on AI training.',
    href: 'https://education.economictimes.indiatimes.com/news/industry/accenture-launches-2-lakh-mba-with-international-accreditation/129648909',
  },
  {
    type: 'article',
    tag: 'Business Standard',
    title: '₹2 Lakh MBA: Accenture bets on affordable AI degrees for new-age careers',
    description: 'How Accenture is making an accredited MBA accessible to Indian professionals for under ₹2 lakh.',
    href: 'https://www.business-standard.com/finance/personal-finance/2-lakh-mba-accenture-bets-on-affordable-ai-degrees-for-new-age-careers-126031800238_1.html',
  },
  {
    type: 'article',
    tag: 'TechObserver',
    title: 'Udacity AI MBA degree launch in India',
    description:
      'Woolf-accredited, ECTS-recognised MBA priced under ₹2 lakh, designed for working professionals entering AI product roles.',
    href: 'https://techobserver.in/education/udacity-ai-mba-degree-launch-india-321632/',
  },
  {
    type: 'article',
    tag: 'Business News This Week',
    title: 'Accredited MBA to train the next generation of AI product leaders',
    description:
      'Learners can earn an MBA degree built around Udacity\u2019s hallmark project-based curriculum at a fraction of the cost.',
    href: 'https://businessnewsthisweek.com/education/udacity-part-of-accenture-launches-accredited-mba-to-train-the-next-generation-of-ai-product-leaders/',
  },
];
